var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',{staticClass:"page-header"},[_vm._v("How to Donate")]),(_vm.$store.state.country == 'can')?_c('how-to-can'):_vm._e(),(_vm.$store.state.country == 'us')?_c('how-to-us'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }